export * from './tipo-significado-rubrica.pipe';
